/**
 * QueuePanel — the CUSTOM Queue tab body. Mounts only for a tracker with a
 * queue (queueProviderOf), so a Tres Commas drawer never builds a queue
 * request.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { TabsContent } from '@/components/ui/layout/Tabs';
import { PreviewSplitLayout } from '@/features/flow-optimizer/components/preview/panel';
import QueueTab from '@/features/flow-optimizer/tabs/queue/QueueTab';
import { queueProviderOf } from '@/features/trackers/flow-optimizer';

import { SPLIT_PANEL_CLASS, type CustomTabPanelsProps } from './panel-props';

const QueuePanel: FC<CustomTabPanelsProps> = (props) => {
  const { campaignId, draft, onChange, provider, splitActive, sidePanel } = props;
  const queue = queueProviderOf(provider);
  if (!queue) return null;
  return (
    <TabsContent value="queue" className={SPLIT_PANEL_CLASS}>
      {/* Same pinned live preview as Rules/Formula — the queue's swaps and
          the preview's verdicts (TRASH & co) belong on one screen. */}
      <PreviewSplitLayout active={splitActive} panel={sidePanel}>
        <QueueTab
          campaignId={campaignId}
          provider={queue}
          killSwitch={draft.killSwitch === true}
          capacityRules={draft.capacityRules ?? []}
          onCapacityRulesChange={(capacityRules) => onChange({ ...draft, capacityRules })}
        />
      </PreviewSplitLayout>
    </TabsContent>
  );
};

export default QueuePanel;
